/*=============================================== WrapperDemo component ===============================================*/

import { DefaultLayout } from "./DefaultLayout"
import { Header } from "./Header"

const WrapperDemo = ({ title, children }: WrapperDemoProps) => {
    return (
        <DefaultLayout title={title}>
            <Header />

            <div style={{ height: 64 }} />

            {children}
        </DefaultLayout>
    )
}

export default WrapperDemo

interface WrapperDemoProps {
    title: string
    children?: any
}
